export const VALID_WHISHLIST_DOMAINS = ['camswag', 'amazon', ['the-stockroom', 'stockroom'], 'edenfantasys'];

export const GAMES = {
  SPIN_THE_WHEEL: 'SpinTheWheel',
  TOKEN_SQUARES: 'TokenSquares',
  ROLL_THE_DICE: 'RollTheDice',
  TIP_MENU: 'TipMenu',
};

export const GAME_OPERATIONS = {
  START: 's',
  STOP: 'e',
  LOCK: 'l',
  UNLOCK: 'ul',
  UPDATE: 'u',
  RESUME: 'res',
};

export const GAMES_STATUS = {
  PAUSE: 'PAUSED',
  IDLE: 'IDLE',
};

export enum CALENDAR_SHOW_TYPE {
  ALL = 'ALL',
  MY_SHOWS = 'MY_SHOWS',
  MY_SUBSCRIPTIONS = 'MY_SUBSCRIPTIONS',
}

export const CALENDAR_MONTH_POSITION = {
  CURRENT: 'CURRENT',
  NEXT: 'NEXT',
  AFTER_NEXT: 'AFTER_NEXT',
  NEXT_AFTER_NEXT: 'NEXT_AFTER_NEXT',
};

export enum CALENDAR_REPEAT_VALUES {
  NEVER = 'NEVER',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export const CALENDAR_TIME_PERIOD = {
  AM: 'AM',
  PM: 'PM',
};

export const GOLD_FAVORITE_GIFT = 'Gold Favorite';

export const STREAM_RECONNECT_TIMEOUT = 16000;

export const NOT_AVAILABLE = 'NOT_AVAILABLE';

export const CONTEXTUAL_GOLD_MODAL_AREAS = {
  GIFTS: 'GIFTS',
  ADS: 'ADS',
  BOOST: 'BOOST',
  PRIVATE_MESSAGING: 'PRIVATE_MESSAGING',
  TRANSLATION: 'TRANSLATION',
  ANONYMOUS_TIPPING: 'ANONYMOUS_TIPPING',
  CHAT_ENHANCEMENTS: 'CHAT_ENHANCEMENTS',
};

export const GOLD_MEMBERSHIP_FEATURES = [
  { text: 'gold.upgrade.watchAndChat', goldOnly: false },
  {
    text: 'gold.upgrade.add.free',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.ADS,
    tooltip: 'gold.upgrade.tooltip.adfree',
  },
  {
    text: 'gold.upgrade.privatemessaging',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.PRIVATE_MESSAGING,
    tooltip: 'gold.upgrade.tooltip.privateMessaging',
  },
  {
    text: 'gold.upgrade.token.offers',
    goldOnly: true,
    tooltip: 'gold.upgrade.tooltip.bonusTokens',
  },
  {
    text: 'gold.upgrade.anonimousTipping',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.ANONYMOUS_TIPPING,
    tooltip: 'gold.upgrade.tooltip.tipping',
  },
  {
    text: 'gold.upgrade.special.gold.chat.status',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.CHAT_ENHANCEMENTS,
    tooltip: 'gold.upgrade.tooltip.special.chat.status',
  },
  {
    text: 'gold.gold.upgrade.single.membership.feature.2',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.TRANSLATION,
    tooltip: 'gold.upgrade.tooltip.automatic.translation',
  },
  {
    text: 'gold.upgrade.free.gold.gift',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.GIFTS,
    tooltip: 'gold.upgrade.tooltip.freeGift',
  },
  {
    text: 'gold.upgrade.freeMonthlyBoost',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.BOOST,
    tooltip: 'gold.upgrade.tooltip.free.boost',
  },
];

export const GOLD_MEMBERSHIP_FEATURES_NN_BUNDLE = [
  { text: 'gold.upgrade.watchAndChat', goldOnly: false },
  {
    text: 'gold.upgrade.add.free',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.ADS,
    tooltip: 'gold.upgrade.tooltip.adfree',
  },
  {
    text: 'gold.upgrade.privatemessaging',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.PRIVATE_MESSAGING,
    tooltip: 'gold.upgrade.tooltip.privateMessaging',
  },
  {
    text: 'gold.upgrade.token.offers',
    goldOnly: true,
    tooltip: 'gold.upgrade.tooltip.bonusTokens',
  },
  {
    text: 'gold.upgrade.anonimousTipping',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.ANONYMOUS_TIPPING,
    tooltip: 'gold.upgrade.tooltip.tipping',
  },
  {
    text: 'gold.upgrade.special.gold.chat.status',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.CHAT_ENHANCEMENTS,
    tooltip: 'gold.upgrade.tooltip.special.chat.status',
  },
  {
    text: 'gold.gold.upgrade.single.membership.feature.2',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.TRANSLATION,
    tooltip: 'gold.upgrade.tooltip.automatic.translation',
  },
  {
    text: 'gold.upgrade.free.gold.gift',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.GIFTS,
    tooltip: 'gold.upgrade.tooltip.freeGift',
  },
  {
    text: 'gold.upgrade.freeMonthlyBoost',
    goldOnly: true,
    area: CONTEXTUAL_GOLD_MODAL_AREAS.BOOST,
    tooltip: 'gold.upgrade.tooltip.free.boost',
  },
  {
    text: 'v2profile.gold.upgrade.nn.gift.value.added',
    goldOnly: true,
  },
  {
    text: 'v2profile.upgrade.gold.modal.nn',
    goldOnly: true,
  },
  {
    text: 'v2profile.upgrade.gold.modal.nn.live',
    goldOnly: true,
  },
];

export const PHONE_WITH_BIG_KEYBOARD_OPEN_HEIGHT = 550;
export const BROADCAST_WINDOW_HEIGHT = 725;
export const BROADCAST_WINDOW_WIDTH = 1200;
export const BROADCAST_WINDOW_HEIGHT_OPERA = 825;
export const STREAM_SOURCE_WEBRTC = 'webrtc';
export const STREAM_SOURCE_EXTERNAL = 'external_encoder';
export const ADAPTERS = {
  CEEBLUE: 'ceeblue',
  WOWZA: 'wowza',
};

export const STREAM_QUALITY = {
  POOR: 'poor',
  GOOD: 'good',
  GREAT: 'great',
  NOT_AVAILABLE: 'notAvailable',
};

export const MODERATION_OPTIONS = {
  MODERATOR: 'moderator',
  REMOVE_MODERATOR: 'remove_moderator',
  BAN: 'ban',
  UNBAN: 'unBan',
  SILENCE: 'silence',
  UNSILENCE: 'unsilence',
  KICK: 'kick',
};

export const FRIEND_REQUEST_ACTIONS = {
  ACCEPT: 'accept',
  IGNORE: 'ignore',
  ACCEPT_ALL: 'acceptAll',
  IGNORE_ALL: 'ignoreAll',
};

export const PRIVATE_SHOW_ACTIONS = {
  START_PS: 'startPS',
  STOP_PS: 'stopPS',
};

export const PAUSE_BROADCAST_OPTIONS = { RESUME: 'RESUME' };

export const STREAM_PROVIDERS = {
  CEEBLUE: 'CEEBLUE',
  WOWZA: 'WOWZA',
};

export const STREAM_PROTOCOL = {
  RTMP: 'RTMP',
  WEBRTC: 'WebRTC',
};

export const DEVICE_ERRORS = {
  NOT_READABLE_ERROR: 'NotReadableError',
  NO_CAMERA_AVAILABLE: 'NoCameraAvailable',
  NO_PERMISSIONS_GIVEN: 'NoPermissionsGiven',
};

export const RESPONSE_STATUSES = {
  STATUS_200: 200,
  STATUS_404: 404,
};

export const TabPanelType = Object.freeze({
  specialShowChat: 0,
  publicChat: 1,
  privateChat: 2,
  userList: 3,
  notifications: 4,
  settings: 5,
});

export const BOTS = {
  WELCOME_BOT: 'Welcome Bot',
  TIP_RESPONSE_BOT: 'Tip Response Bot',
  AUTO_NOTIFICATION_BOT: 'Auto Notification Bot',
};
